import React from "react";
import { Stack, Text } from "@bookingcom/bui-react";
import FareCalendarLegendBadges from "./FareCalendarLegendBadges.js";
import styles from "./FareCalendarLegend.module.css";
export default function FareCalendarLegend({ text, low, medium, high, loading = false, addContainer = true }) {
    return (React.createElement(Stack, { direction: "row", alignItems: "center", justifyContent: "space-between", gap: 4, className: addContainer ? styles.container : "" },
        React.createElement(Text, { variant: "small_1", className: styles.text }, text),
        React.createElement(Stack, { direction: "row", gap: 2 },
            React.createElement(FareCalendarLegendBadges, { low: low, medium: medium, high: high, loading: loading }))));
}
